// extracted by mini-css-extract-plugin
module.exports = {"topbanner":"TopBanner_topbanner__bPMxU"};